import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApplicationFormOverview, CompletedApplicationForm} from '../../model/application';
import {ApplicationFormComponent} from '../application-form/application-form.component';
import {CommonModule} from '@angular/common';
import {
  ApplicationResource,
  ApplicationsService,
  FormsService,
  StepResource
} from '../../core/modules/openapi';
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {CompletedStep} from "../../model/step";
import {ApplicationOutlineComponent} from "../application-outline/application-outline.component";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-application-update',
  imports: [ApplicationFormComponent, CommonModule, MatCardModule, MatButtonModule, ApplicationOutlineComponent],
  templateUrl: './application-update.component.html',
  standalone: true,
  styleUrl: './application-update.component.sass'
})
export class ApplicationUpdateComponent implements OnInit {
  application: ApplicationFormOverview;
  completedApplicationForm = new CompletedApplicationForm();
  currentStep: StepResource;
  applicationResource: ApplicationResource;
  currentStepIndex = 0;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly formsService: FormsService,
    private readonly applicationService: ApplicationsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id')!;
    this.formsService.getApplicationFormById(id).subscribe(response => {
      this.application = response;
      this.completedApplicationForm.id = this.application.id;
    });
    this.formsService.getStepBySequence(id, this.currentStepIndex).subscribe(response => {
      this.currentStep = response;
    });
    this.applicationService.getApplicationById(id).subscribe(response => {
      this.applicationResource = response;
    });
  }

  // stepChanged(newStepIndex: number) {
  //   this.formsService.getStepBySequence(this.application.id, newStepIndex).subscribe(response => {
  //     this.currentStep = response;
  //   });
  // }

  stepCompleted(completedStep: CompletedStep) {
    if (completedStep.stepData) {
      this.currentStepIndex = completedStep.nextIndex;
      this.completedApplicationForm.steps.set(completedStep.completedIndex, completedStep.stepData);
      console.log(completedStep);
      this.formsService.saveStepData(this.application.id, completedStep.completedIndex, undefined, completedStep.stepData).subscribe({
        complete: () => {
          if (this.application.steps.length === this.currentStepIndex) {
            this.router.navigate(["home"]);
          } else {
            this.formsService.getStepBySequence(this.application.id, this.currentStepIndex).subscribe(response => {
              this.currentStep = response;
            });
          }
        },
        error: err => {
          this.snackBar.open("Error al enviar la aplicación: " + err.error.detail, 'Cerrar', {duration: 5000})
          this.router.navigate(["home"]);
        }
      });
    } else if (this.currentStepIndex != completedStep.nextIndex) {
      this.formsService.getStepBySequence(this.application.id, completedStep.nextIndex).subscribe(response => {
        this.currentStep = response;
        this.currentStepIndex = completedStep.nextIndex;
      });
    }
  }
}
